import { cn } from 'components/UI/cn'
import { FloatingTooltip } from 'components/Tooltip/FloatingTooltip'

// DS2026 entity chip — neutral gray fill, no border (matches the compose
// recipient chips). On the sage selected inbox row it's flipped to white via
// `.deal-badge` in EMAIL_TABLE_OVERRIDES so it stays legible.
export const CATEGORY_BADGE_CLASS =
  'inline-flex items-center flex-shrink-0 whitespace-nowrap px-1.5 py-0.5 text-xs font-medium text-neutral-700 bg-neutral-100 rounded-md leading-[14.4px] tracking-[0.09px]'

// DS2026 neutral chip — the default gray tag look (neutral-100 fill, no border)
// for plain entity labels like a company name, distinct from the branded
// (sage) deal chip above.
export const COMPANY_BADGE_CLASS =
  'inline-flex items-center flex-shrink-0 whitespace-nowrap px-2 py-0.5 text-xs font-medium text-neutral-700 bg-neutral-100 rounded-md leading-[14.4px] tracking-[0.09px]'

interface DealBadgeProps {
  dealIdentifier: string
  dealName?: string | null
  onClick?: () => void
}

/** Green outlined pill showing "Deal #XXXXX" with optional tooltip for deal name. */
export function DealBadge({
  dealIdentifier,
  dealName,
  onClick,
}: DealBadgeProps) {
  const badge = (
    <span
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (e) => (e.key === 'Enter' || e.key === ' ') && onClick()
          : undefined
      }
      className={cn(
        CATEGORY_BADGE_CLASS,
        'deal-badge',
        onClick && 'cursor-pointer hover:bg-neutral-200'
      )}
    >
      Deal #{dealIdentifier}
    </span>
  )

  if (dealName) {
    return (
      <FloatingTooltip text={dealName} theme="dark">
        {badge}
      </FloatingTooltip>
    )
  }

  return badge
}
